'use strict'

const CarouselManager = {
    init: function () {
        var blocs = document.querySelectorAll(".c-carousel_container_homepage");

        for (var i = 0; i < blocs.length; i++) {
            new Carousel(blocs[i]);
        }
    }
}

class Carousel {
    constructor(item) {
        this.parent = item;
        this.bloc = this.parent.querySelector('.c-carousel_container');
        this.prev = this.parent.querySelector('.c-carousel_button_prev');
        this.next = this.parent.querySelector('.c-carousel_button_next');
        this.currentLeft = 0;
        this.STEP = 300;
        this.startX = 0;
        this.startScroll = 0;
        this.isDown = false;
        this.isTouch = false;
        this.carouselCustom();
        this.render();
    }

    carouselCustom() {
        this.next.addEventListener("click", this.goNext.bind(this));
        this.prev.addEventListener("click", this.goPrev.bind(this));
        this.bloc.addEventListener("mousedown", this.mouseStart.bind(this));
        this.bloc.addEventListener("mouseup", this.mouseEnd.bind(this));
        this.bloc.addEventListener("mousemove", this.mouseMove.bind(this));
        this.bloc.addEventListener("mouseleave", this.mouseEnd.bind(this));
        this.bloc.addEventListener("touchstart", this.touchStart.bind(this));
        window.addEventListener("touchend", this.touchEnd.bind(this));
        window.addEventListener("mouseleave", this.mouseEnd.bind(this));
    }

    touchStart(e) {
        this.isTouch = true;
        this.bloc.style.overflowX = "auto";
    }

    touchEnd(e) {
        // this.isTouch = false;
        // this.currentLeft = this.bloc.scrollLeft;
    }

    mouseStart(e) {
        this.isDown = true;
        this.startScroll = this.bloc.scrollLeft;
        this.startX = e.clientX;
    }

    mouseEnd(e) {
        this.isDown = false;
    }

    mouseMove(e) {
        e.preventDefault();
        if (this.isDown) {
            var nextScroll = this.startScroll + (this.startX - e.clientX);
            this.bloc.scrollLeft = nextScroll;
            this.currentLeft = nextScroll;
        }
    }

    goNext() {
        if (this.isTouch) {
            this.isTouch = false;
            this.currentLeft = this.bloc.scrollLeft;
        }
        this.setNextLeft(this.currentLeft + this.STEP)
    }

    goPrev() {
        if (this.isTouch) {
            this.isTouch = false;
            this.currentLeft = this.bloc.scrollLeft;
        }
        this.setNextLeft(this.currentLeft - this.STEP)
    }

    setNextLeft(nextLeft) {
        var maxLeft = this.bloc.scrollWidth - this.bloc.clientWidth;
        if (nextLeft <= 0) {
            this.currentLeft = 0;
        } else if (nextLeft >= maxLeft) {
            this.currentLeft = maxLeft;
        } else {
            this.currentLeft = nextLeft;
        }
    }

    render() {
        if (!this.isTouch) {
            var scrollLeft = this.bloc.scrollLeft;
            var maxLeft = this.bloc.scrollWidth - this.bloc.clientWidth;

            if (this.currentLeft != scrollLeft) {
                var diff = this.currentLeft - scrollLeft;
                var sens = Math.abs(diff) / diff;
                if (Math.abs(diff) < 25) {
                    this.bloc.scrollLeft = this.currentLeft;
                } else {
                    this.bloc.scrollLeft += (sens) * 10;
                }
            }

            if (scrollLeft <= 0) {
                this.prev.classList.add("c-carousel_button_prev--disable")
            } else {
                this.prev.classList.remove("c-carousel_button_prev--disable")
            }

            if (scrollLeft >= maxLeft) {
                this.next.classList.add("c-carousel_button_next--disable")
            } else {
                this.next.classList.remove("c-carousel_button_next--disable")
            }

            if(scrollLeft <= 0 && scrollLeft >= maxLeft){
                this.prev.classList.add("c-carousel_button_prev--hidden")
                this.next.classList.add("c-carousel_button_next--hidden")
            } else {
                this.prev.classList.remove("c-carousel_button_prev--hidden")
                this.next.classList.remove("c-carousel_button_next--hidden")
            }
        }

        requestAnimationFrame(this.render.bind(this));
    }
}


export default CarouselManager;


// WEBPACK FOOTER //
// ./src/scripts/components/Carousel.js